import React from 'react';
import error from '../../../assets/images/icons/error.png';
import info from '../../../assets/images/icons/info.png';
import success from '../../../assets/images/icons/success.png';
import warning from '../../../assets/images/icons/warning.png';
import styles from './Toast.module.scss';
import PropTypes from 'prop-types';

export const Toast = (props) => {
  const {message, type} = props;
  const icons = {error, info, success, warning};

  return (
    <div className={styles.container}>
      <img src={icons[type]} alt="" className={styles.imageContainer}/>
      <span>{message}</span>
    </div>
  );
};

Toast.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
  closeToast: PropTypes.func
}

Toast.defaultProps = {}

export default Toast;